import {useTranslation} from "react-i18next";
import React, {useState} from "react";
import Auxiliary from "../../../../hoc/Auxiliary";

const orderCancel = (props) => {
    const {t, i18n} = useTranslation();
    const [reason, setReason] = useState('');

    const setTheData = () => {
        let cancelation = {
            "results": [
                {
                    "onlineOrderId": props.data.onlineOrderId,
                    "orderStatus": "C",
                    "canceledReason": reason,
                    "errorMessage": ""
                }
            ]
        };
        props.actionConfirm(cancelation);
    }

    return (
        <Auxiliary>
            <div className="row row--rmline  ">
                <div className="col-12 mb-3">
                    {t('popuporderstatus.cancel.main')}?
                </div>

                <div className="col-12">
                    <label htmlFor={'reason'} className="input-field">{t("popuporderstatus.cancel.reason")}<br/>
                        <textarea name={'note'} className="_full" placeholder={t("popuporderstatus.cancel.reasonmore")}
                                  defaultValue={''} onChange={(e) => setReason(e.target.value)}/>
                    </label>
                </div>
            </div>
            <div className="row row--rmline ">
                <div className="col-12 d-flex justify-content-end">
                    <button className="btn btn--outline btn--outline--black btn--fs-12 mr-4"
                            onClick={props.actionClose}>
                        {t("popuporderstatus.cancel.close")}
                    </button>
                    <button className="btn btn--raised btn--raised--red btn--fs-12" onClick={setTheData}>
                        {t("popuporderstatus.cancel.confirm")}
                    </button>
                </div>
            </div>
        </Auxiliary>
    )
};
export default orderCancel;
